module.exports = Joi => Joi.string().email({ minDomainSegments: 2, tlds: { allow: false } })
